import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from './button'
import classNames from 'classnames'

const styles = theme => ({
  frame: {
    margin: 10,
    boxSizing: 'border-box',
    padding: '35px 35px 45px 35px',
    textAlign: 'center',
    borderRadius: 5,
    boxShadow: theme.shadows[2],
    background: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  text: {
    margin: '20px 0 30px 0',
    fontSize: '2rem',
    fontWeight: 300,
  },
  description: {
    margin: '15px 0 30px 0',
  },
  button: {
    padding: '6px 24px',
    borderRadius: 22,
  },
  helperText: {
    marginTop: 10,
    marginBottom: -10,
  },
  img: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
})

const Frame = ({classes, image, text, buttonText, onClick, helperText, className, description = '', invertImgPosition = false, buttonProps = {}, imgProps = {}, ...props}) => (
  <div className={classNames(classes.frame, className)} {...props}>
    {invertImgPosition === true ? null : <img src={image} alt={''} {...imgProps}/>}
    <Typography variant={'headline'} align={'center'} color={'primary'} className={classes.text}>
      {text}
    </Typography>
    {invertImgPosition === true ? <div className={classes.img}><img src={image} alt={''} {...imgProps}/></div> : null}
    {description !== '' ? (
      <Typography variant={'subheading'} align={'center'} color={'textSecondary'} className={classes.description}>
        {description}
      </Typography>
    ) : null}
    <Button variant={'primary'} onClick={onClick} className={classes.button} {...buttonProps}>
      {buttonText}
    </Button>
    <Typography variant={'body1'} align={'center'} color={'secondary'} className={classes.helperText}>
      {helperText}
    </Typography>
  </div>
)

Frame.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  invertImgPosition: PropTypes.bool,
  buttonProps: PropTypes.object,
  imgProps: PropTypes.object,
}

export default withStyles(styles, {withTheme: true})(Frame)



// WEBPACK FOOTER //
// ./src/components/frame.jsx